export function getRegistrationCellValue(record, field) {
  let formData = {};
  try {
    formData = record.form_data ? JSON.parse(record.form_data) : {};
  } catch (e) {
    formData = {};
  }

  if (field.type === 'school') {
    return [
      formData.school_province || record.school_province,
      formData.school_ward || record.school_ward,
      formData.school_name || record.school_name,
    ]
      .filter(Boolean)
      .join(' / ');
  }

  const name = field.name;
  const value = formData[name] ?? record[name];
  return value ?? '';
}

export function buildRegistrationTableColumns(fields = []) {
  const cols = [
    { title: 'ID', dataIndex: 'id', width: 70, fixed: 'left' },
    {
      title: 'Thời gian đăng ký',
      dataIndex: 'created_at',
      width: 160,
    },
  ];

  fields.forEach((field, index) => {
    if (field.type === 'school') {
      cols.push({
        title: field.label || 'Trường THPT',
        key: `school-${index}`,
        render: (_, record) => getRegistrationCellValue(record, field),
      });
      return;
    }
    cols.push({
      title: field.label || field.name,
      key: `${field.name}-${index}`,
      render: (_, record) => getRegistrationCellValue(record, field),
    });
  });

  return cols;
}
